import { z } from 'zod';
import { FlowProducedType } from '../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export var FlowEvaluationType;
(function (FlowEvaluationType) {
    FlowEvaluationType["Accuracy"] = "ACCURACY";
    FlowEvaluationType["SemanticSimilarity"] = "SEMANTIC_SIMILARITY";
    FlowEvaluationType["Faithfulness"] = "FAITHFULNESS";
})(FlowEvaluationType || (FlowEvaluationType = {}));
export const FlowEvaluationBlockConfigSchema = z.object({
    output: z.string().min(1, { message: 'Generated value is required' }),
    reference: z.string().min(1, { message: 'Source value is required' }),
    evaluationType: z.enum(FlowEvaluationType, {
        message: 'Evaluation type is required',
    }),
});
export const FlowEvaluationBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Evaluation),
    config: FlowEvaluationBlockConfigSchema,
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.Evaluation),
});
//# sourceMappingURL=config.js.map